import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';
import { Field } from 'formik';
import classNames from 'classnames';

function FormCheckboxFieldInner(props) {
  const { label, form, field, disabled, id, className, required, size, helperText } = props;
  const error = form.errors[field.name];
  const touched = form.touched[field.name];
  const hasError = error && (touched || form.submitCount > 0);
  const labelClassName = classNames('form-checkbox__label', {
    'form-checkbox__label--disabled': disabled,
    'form-checkbox__label--error': hasError,
    'form-checkbox__label--required': required,
  });

  const formGroupClassName = classNames('form-group', className, {
    'form-group--error': hasError,
    [`form-group--${size}`]: size,
  });

  let describedBy;
  if (hasError) {
    describedBy = `${field.name}-error`;
  } else if (helperText) {
    describedBy = `${field.name}-helper`;
  }

  return (
    <FormGroup check disabled={form.isSubmitting} className={formGroupClassName}>
      <Label check className={labelClassName}>
        <Input
          type="checkbox"
          name={field.name}
          onBlur={field.onBlur}
          onChange={field.onChange}
          checked={field.value || false}
          disabled={disabled || form.isSubmitting}
          id={id}
          aria-invalid={hasError}
          aria-describedby={describedBy}
        />
        <span className="form-check-sign">
          <span className="check" />
        </span>
        <span className="form-checkbox__label-text">
          {label}
          {required && (
            <span className="form-checkbox__required-asterisk" aria-label="required">
              {' '}
              *
            </span>
          )}
        </span>
      </Label>
      {helperText && !hasError && (
        <div id={`${field.name}-helper`} className="form-checkbox__helper-text">
          {helperText}
        </div>
      )}
      {hasError && (
        <div
          id={`${field.name}-error`}
          className="form-checkbox__error-message"
          role="alert"
          aria-live="polite"
        >
          {error}
        </div>
      )}
    </FormGroup>
  );
}

function FormCheckboxFieldFixed(props) {
  return <Field {...props} component={FormCheckboxFieldInner} />;
}

FormCheckboxFieldFixed.defaultProps = {
  disabled: false,
  className: '',
  required: false,
  size: null,
  id: null,
  helperText: null,
};

FormCheckboxFieldFixed.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg']),
  id: PropTypes.string,
  helperText: PropTypes.string,
};

export default FormCheckboxFieldFixed;
